import { render, staticRenderFns } from "./NewSignUp.vue?vue&type=template&id=08dc861f"
import script from "./NewSignUp.vue?vue&type=script&lang=js"
export * from "./NewSignUp.vue?vue&type=script&lang=js"
import style0 from "./NewSignUp.vue?vue&type=style&index=0&id=08dc861f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports